import { PERMISSIONS, hasPermission } from '../auth/permissions';

const MASTER_MENU_ITEMS = [
    // --- YÖNETİM PANELİ (executive cockpit — ayrı grup, en üstte) ---
    { id: 'yonetim-paneli', label: 'Yönetim Paneli', icon: '🎯', route: '/yonetim-paneli', permission: PERMISSIONS.VIEW_EXECUTIVE_COCKPIT, group: 'Yönetim Paneli' },

    // --- ANA SAYFA ---
    { id: 'dashboard', label: 'Pano', icon: '📊', route: '/dashboard', permission: PERMISSIONS.VIEW_PAGE_DASHBOARD, group: 'Ana Sayfa' },

    // --- SATINALMA (Birleşik) ---
    { id: 'satinalma', label: 'Satınalma', icon: '🛒', route: '/satinalma', permission: PERMISSIONS.VIEW_PAGE_REQUESTS, group: 'Satınalma' },

    // --- STOK & DEPO (Birleşik) ---
    { id: 'stok-depo', label: 'Stok & Depo', icon: '📦', route: '/stok-depo', permission: PERMISSIONS.VIEW_PAGE_INVENTORY, group: 'Stok & Depo' },
    
    {
        id: 'transfer',
        label: 'Transfer',
        icon: '🚚',
        route: '/inventory',
        permission: PERMISSIONS.VIEW_PAGE_TRANSFER,
        group: 'Stok & Depo'
    },    

    // --- ÜRETİM (Birleşik) ---
    { id: 'uretim', label: 'Üretim', icon: '🏭', route: '/uretim', permission: PERMISSIONS.MANAGE_PRODUCTION, group: 'Üretim' },

    // --- REÇETE & MALİYET (Birleşik) ---
    { id: 'recete-maliyet', label: 'Reçeteler', icon: '📋', route: '/recete-maliyet', permission: PERMISSIONS.VIEW_PAGE_RECIPES, group: 'Reçete & Maliyet' },

    // --- POS & SATIŞ (Birleşik tab sayfası) ---
    { id: 'satis-analiz', label: 'Satış', icon: '📊', route: '/satis-analiz', permission: PERMISSIONS.VIEW_POS_DATA, group: 'Satış & Analiz' },

    // --- SATIŞLAR (Dış Müşteri Satışı) — çok-sayfalı modül, grup açılır menü ---
    { id: 'satislar-alacak', label: 'Alacak Takibi', icon: '📊', route: '/satislar/alacak-takibi', permission: PERMISSIONS.VIEW_PAGE_SATIS, group: 'Satışlar' },
    { id: 'satislar-musteriler', label: 'Müşteriler', icon: '🧾', route: '/satislar/musteriler', permission: PERMISSIONS.VIEW_PAGE_SATIS, group: 'Satışlar' },
    { id: 'satislar-irsaliyeler', label: 'İrsaliyeler', icon: '📦', route: '/satislar/irsaliyeler', permission: PERMISSIONS.VIEW_PAGE_SATIS, group: 'Satışlar' },
    { id: 'satislar-faturalar', label: 'Faturalar', icon: '🧾', route: '/satislar/faturalar', permission: PERMISSIONS.VIEW_PAGE_SATIS, group: 'Satışlar' },
    { id: 'satislar-tahsilatlar', label: 'Tahsilatlar', icon: '💵', route: '/satislar/tahsilatlar', permission: PERMISSIONS.VIEW_PAGE_SATIS, group: 'Satışlar' },
    { id: 'satislar-iadeler', label: 'İadeler', icon: '↩️', route: '/satislar/iadeler', permission: PERMISSIONS.VIEW_PAGE_SATIS, group: 'Satışlar' },

    // --- MUHASEBE (Birleşik) ---
    // Tam muhasebe yetkisi olan kullanıcılar
    { 
        id: 'finans', 
        label: 'Muhasebe', 
        icon: '💰', 
        route: '/finans', 
        permission: PERMISSIONS.VIEW_PAGE_FINANCE, 
        group: 'Muhasebe' 
    },
    
    // Sadece Fatura Girişi yetkisi olan kullanıcılar
    { 
        id: 'fatura-girisi', 
        label: 'Fatura Girişi', 
        icon: '🧾', 
        route: '/fiyat-girisi', 
        permission: PERMISSIONS.VIEW_PAGE_FATURA_GIRISI, 
        group: 'Muhasebe' 
    },

    // --- MUHASEBE-LOGO ---
    // Mevcut ERP verilerini Logo görünümüne yakın, ayrı bir muhasebe menüsünde toplar.
    { id: 'muhasebe-logo', label: 'Muhasebe-Logo', icon: '🏦', route: '/muhasebe-logo', permission: PERMISSIONS.VIEW_PAGE_FINANCE, group: 'Muhasebe-Logo' },

    // --- İNSAN KAYNAKLARI (Birleşik tab) ---
    { id: 'ik', label: 'İnsan Kaynakları', icon: '👥', route: '/ik', permission: PERMISSIONS.MANAGE_HR, group: 'İnsan Kaynakları' },

    // --- RAPORLAR (Birleşik) ---
    { id: 'raporlar-grup', label: 'Raporlar', icon: '📈', route: '/raporlar-grup', permission: PERMISSIONS.VIEW_PAGE_REPORTS, group: 'Raporlar' },

    // --- TEDARİKÇİLER (Birleşik) ---
    { id: 'tedarikciler-grup', label: 'Tedarikçiler', icon: '🏭', route: '/tedarikciler-grup', permission: PERMISSIONS.VIEW_PAGE_SUPPLIERS, group: 'Tedarikçiler' },

    // --- ENTEGRASYON (Birleşik) ---
    { id: 'entegrasyon', label: 'Entegrasyon', icon: '🔗', route: '/entegrasyon', permission: PERMISSIONS.MANAGE_SETTINGS, group: 'Entegrasyon' },

    // --- AYARLAR (Birleşik) — id/route 'yonetim' korunur (iç tanımlayıcı, referans bütünlüğü) ---
    { id: 'yonetim', label: 'Ayarlar', icon: '⚙️', route: '/yonetim', permission: PERMISSIONS.MANAGE_USERS, group: 'Ayarlar' },
];

// Grup ikonları
export const GROUP_ICONS = {
    'Yönetim Paneli': '🎯',
    'Ana Sayfa': '🏠',
    'Satınalma': '🛒',
    'Stok & Depo': '📦',
    'Üretim': '🏭',
    'Reçete & Maliyet': '📋',
    'Satış & Analiz': '🧾',
    'Satışlar': '🧾',
    'Muhasebe': '💰',
    'Muhasebe-Logo': '🏦',
    'İnsan Kaynakları': '👥',
    'Raporlar': '📈',
    'Tedarikçiler': '🏭',
    'Entegrasyon': '🔗',
    'Ayarlar': '⚙️',
};

export const getMenusForRole = (role, effectivePermissions = []) => {
    return MASTER_MENU_ITEMS.filter(item => {
        if (!item.permission) return true;
        return hasPermission(role, item.permission, effectivePermissions);
    });
};

// Gruplu menü döndürür: [{ group, icon, items: [...] }]
export const getGroupedMenus = (role, effectivePermissions = []) => {
    const filtered = getMenusForRole(role, effectivePermissions);
    const groups = [];
    const groupMap = {};
    for (const item of filtered) {
        const g = item.group || 'Diğer';
        if (!groupMap[g]) {
            groupMap[g] = { group: g, icon: GROUP_ICONS[g] || '📌', items: [] };
            groups.push(groupMap[g]);
        }
        groupMap[g].items.push(item);
    }
    // Rol bazlı sıralama
    const order = ROLE_GROUP_ORDER[role];
    if (order) {
        groups.sort((a, b) => {
            const ai = order.indexOf(a.group);
            const bi = order.indexOf(b.group);
            const aIdx = ai === -1 ? 999 : ai;
            const bIdx = bi === -1 ? 999 : bi;
            return aIdx - bIdx;
        });
    }

    return groups;
};

// Rol bazlı grup sıralaması — listede olmayan gruplar sona eklenir
export const ROLE_GROUP_ORDER = {
  muhasebe: ['Ana Sayfa', 'Muhasebe', 'Muhasebe-Logo', 'Raporlar', 'Tedarikçiler', 'Stok & Depo'],
  satinalma: ['Ana Sayfa', 'Satınalma', 'Stok & Depo', 'Tedarikçiler', 'Reçete & Maliyet'],
  uretim: ['Ana Sayfa', 'Üretim', 'Stok & Depo', 'Reçete & Maliyet'],
  sube: ['Ana Sayfa', 'Stok & Depo'],
  depo: ['Ana Sayfa', 'Stok & Depo'],
  operasyon: ['Ana Sayfa', 'Üretim', 'Raporlar', 'Stok & Depo'],
  ik: ['Ana Sayfa', 'İnsan Kaynakları'],
};

// Varsayılan açık gruplar (role göre ilk 2)
export const ROLE_DEFAULT_OPEN_GROUPS = {
  muhasebe: ['Ana Sayfa', 'Muhasebe'],
  satinalma: ['Ana Sayfa', 'Satınalma'],
  uretim: ['Ana Sayfa', 'Üretim'],
  sube: ['Ana Sayfa', 'Stok & Depo'],
  depo: ['Ana Sayfa', 'Stok & Depo'],
  operasyon: ['Ana Sayfa', 'Üretim'],
  ik: ['Ana Sayfa', 'İnsan Kaynakları'],
};

export const ROLE_MENUS = {};
